<div class="container">
  <div>
    <img
      alt="beauty-booking"
      src="assets/images/logos/beauty-booking-logo.png"
    />
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
